exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.filter-container[data-v-15614488] {\r\n    padding: auto;\r\n    margin-left: 20px;\r\n    padding-top: 20px;\n}\n.my-form[data-v-15614488] {\r\n    max-height: 145px;\r\n    overflow: auto;\n}\n.my-form-item[data-v-15614488] {\r\n    margin-top: 10px;\n}\n.my-input[data-v-15614488] {\r\n    width: 200px;\n}\n.input_number .el-input__inner[data-v-15614488] {\r\n    pointer-events: none;\r\n\r\n    -webkit-user-select: none;\r\n\r\n       -moz-user-select: none;\r\n\r\n        -ms-user-select: none;\r\n\r\n            user-select: none;\n}\r\n", ""]);

// exports
